<template>
    <div class="c-media-gallery-modal">
        <div class="c-media-gallery-modal--backdrop" @click="handleModalClose()"></div>

        <div class="c-media-gallery-modal--contentwrapper">
            <div class="c-media-gallery-modal--content" :style="{ 'width': `${contentWidth}px` }">

                <div class="c-media-gallery-modal--mediawrapper" :class="{ 'has-caption': currentImage.caption }"
                    ref="mediaWrapper" :style="{ 'height': `${contentHeight}px` }">

                    <div class="c-media-gallery-modal--mainmedia">
                        <div class="c-media-gallery-modal--transformwrapper" ref="transformWrapper"
                            :style="{ scale: imageScale, left: `${this.positionX}px`, top: `${this.positionY}px` }">
                            <img :src="currentImage.url" v-on:load="handleImageLoad" />
                        </div>
                    </div>

                    <div class="c-media-gallery-modal--modaltoggle">
                        <div class="c-media-gallery-modal--button" @click="handleModalClose()">
                            <v-icon name="icon-minimize" size="xs"></v-icon>
                        </div>
                    </div>

                    <div class="c-media-gallery-modal--zoomcontrols">
                        <div class="c-media-gallery-modal--button" @click="handleZoomIn()">
                            <v-icon name="icon-zoom-in" size="xs"></v-icon>
                        </div>

                        <div class="c-media-gallery-modal--button" @click="handleZoomOut()">
                            <v-icon name="icon-zoom-out" size="xs"></v-icon>
                        </div>
                    </div>
                </div>

                <div class="c-media-gallery-modal--footer" ref="modalFooter">
                    <div class="c-media-gallery-modal--caption" v-if="currentImage.caption">{{ currentImage.caption }}</div>

                    <div class="c-media-gallery-modal--navigation">
                        <button class="left" @click="handlePreviousClick">
                            <v-icon name="icon-chevron" size="xs"></v-icon>
                        </button>
                        <span>{{ navigationText }}</span>
                        <button @click="handleNextClick">
                            <v-icon name="icon-chevron" size="xs"></v-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VIcon from "../icon/VIcon.vue";

export default {
    name: 'VMediaGalleryModal',
    components: {
        VIcon
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        currentParentIndex: {
            type: Number,
            default: 0
        },
        navigationPrefix: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            currentZoom: 1,
            minZoom: 1,
            maxZoom: 3,
            activeIndex: 0,
            positionX: 0,
            positionY: 0,
            isDragging: false,
            previousX: 0,
            previousY: 0,
            viewPortPaddingDesktop: 50,
            viewPortPaddingMobile: 10,
            currentImageWidth: 0,
            currentImageHeight: 0,
            footerHeight: 0
        }
    },
    computed: {
        maxWidth: function(){
            window.innerWidth - (this.viewPortPaddingDesktop * 2);
        },
        currentImage: function () {
            return this.items[this.activeIndex];
        },
        currentSlidePosition: function () {
            return this.activeIndex + 1;
        },
        itemCount: function () {
            return this.items.length;
        },
        imageScale: function () {
            return this.currentZoom;
        },
        navigationText: function () {
            const baseText = `${this.currentSlidePosition} / ${this.itemCount}`;

            if (this.navigationPrefix) {
                return `${this.navigationPrefix} ${baseText}`;
            }

            return baseText;
        },
        isLandscape: function () {
            return this.currentImageWidth > this.currentImageHeight;
        },
        isMobile: function () {
            return window.innerHeight > window.innerWidth;
        },
        imageRatio: function () {
            return this.currentImageWidth / this.currentImageHeight;
        },
        contentWidth: function () {

            if (this.isMobile) {
                return window.innerWidth - (this.viewPortPaddingMobile * 2);
            }

            let tempWidth = this.contentHeight * this.imageRatio;

            if (tempWidth > this.maxWidth) tempWidth = this.maxWidth;

            return tempWidth;

            if (!this.isLandscape) {
                return this.currentImageWidth;
            }

            return window.innerWidth - (this.viewPortPadding * 2);
        },
        contentHeight: function () {
            if (this.isMobile) {
                return (this.contentWidth / this.imageRatio) - this.footerHeight;
            }

            return ((window.innerHeight) - ((this.viewPortPaddingDesktop * 2))) - this.footerHeight;
        }
    },
    methods: {
        handleImageLoad(e) {
            this.currentImageWidth = e.target.naturalWidth;
            this.currentImageHeight = e.target.naturalHeight;
            const elm = this.$refs.modalFooter;
            this.footerHeight = elm ? Math.floor(elm.offsetHeight) : 0;
        },
        positionImage(pageX, pageY) {
            const transformWrapper = this.$refs.transformWrapper;
            //const mediaWrapper = this.$refs.mediaWrapper;

            const scaleX = Math.round(transformWrapper.offsetWidth * this.currentZoom);
            const scaleY = Math.round(transformWrapper.offsetHeight * this.currentZoom);
            const diffX = (pageX - this.previousX);
            const diffY = (pageY - this.previousY);

            let xBoundBoxMin = 0;
            let xBoundBoxMax = 0;
            let yBoundBoxMin = 0;
            let yBoundBoxMax = 0;

            /*  if (this.currentZoom === 1) {
                  const wrapperWidth = mediaWrapper.offsetWidth;
                  const wrapperHeight = mediaWrapper.offsetHeight;
  
                  xBoundBoxMin = (scaleX - wrapperWidth);
                  yBoundBoxMin = (scaleY - wrapperHeight);
              } else {*/
            xBoundBoxMin = (scaleX - transformWrapper.offsetWidth) / this.currentZoom;
            xBoundBoxMax = (scaleX - transformWrapper.offsetWidth) / this.currentZoom;
            yBoundBoxMin = (scaleY - transformWrapper.offsetHeight) / this.currentZoom;
            yBoundBoxMax = (scaleY - transformWrapper.offsetHeight) / this.currentZoom;
            // }

            if (diffX >= -xBoundBoxMin && diffX <= xBoundBoxMax) {
                this.positionX = diffX;
            }

            if (diffY >= -yBoundBoxMin && diffY <= yBoundBoxMax) {
                this.positionY = diffY;
            }
        },
        getEventCoordinates(e) {
            const x = e.pageX || e.changedTouches[0].pageX;
            const y = e.pageY || e.changedTouches[0].pageY;

            return { x: x, y: y };
        },
        onMouseDown(e) {
            const elem = this.$refs.transformWrapper;
            const coordinates = this.getEventCoordinates(e);

            this.isDragging = true;
            this.previousX = coordinates.x - elem.offsetLeft;
            this.previousY = coordinates.y - elem.offsetTop;

            this.offsetLeft = elem.offsetLeft;
            this.offsetTop = elem.offsetTop;

            e.preventDefault();
        },
        onMouseUp(e) {
            this.isDragging = false;
            this.previousX = 0;
            this.previousY = 0;
        },
        onMouseMove(e) {
            if (this.isDragging) {
                const coordinates = this.getEventCoordinates(e);
                this.positionImage(coordinates.x, coordinates.y);
            }
        },

        onKeyDown(e) {
            if (e.key === "Escape") this.handleModalClose();
            if (e.key === "ArrowLeft") this.handlePreviousClick();
            if (e.key === "ArrowRight") this.handleNextClick();
            if (e.key === "+") this.handleZoomIn();
            if (e.key === "-") this.handleZoomOut();
        },
        handleZoomIn() {
            this.currentZoom = this.currentZoom >= this.maxZoom ? this.maxZoom : this.currentZoom + 1;

            if (this.currentZoom > this.maxZoom) this.currentZoom = this.maxZoom;
        },
        handleZoomOut() {
            this.currentZoom = this.currentZoom <= this.minZoom ? this.minZoom : this.currentZoom - 1;

            if (this.currentZoom === this.minZoom) {
                this.positionX = 0;
                this.positionY = 0;
            }

            if (this.currentZoom < this.minZoom) this.currentZoom = this.minZoom;

            this.positionImage(0, 0);
        },
        handlePreviousClick() {
            this.activeIndex = this.activeIndex <= 0 ? this.itemCount - 1 : this.activeIndex - 1;
            this.resetViewport();
        },
        handleNextClick() {
            this.activeIndex = this.activeIndex >= this.itemCount - 1 ? 0 : this.activeIndex + 1;
            this.resetViewport();
        },
        handleModalClose() {
            this.$emit("onClose");
        },
        resetViewport() {
            this.positionX = 0;
            this.positionY = 0;
            this.currentZoom = this.minZoom;
        }
    },
    mounted() {
        this.activeIndex = this.currentParentIndex;

        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        document.getElementsByTagName('body')[0].style.touchAction = 'none';

        window.addEventListener('keydown', this.onKeyDown);

        window.addEventListener('mousedown', this.onMouseDown);
        window.addEventListener('mouseup', this.onMouseUp);
        window.addEventListener('mousemove', this.onMouseMove);

        window.addEventListener('touchstart', this.onMouseDown);
        window.addEventListener('touchend', this.onMouseUp);
        window.addEventListener('touchmove', this.onMouseMove);
    },
    destroyed() {
        document.getElementsByTagName('body')[0].style.overflow = null;
        document.getElementsByTagName('body')[0].style.touchAction = null;

        window.removeEventListener('keydown', this.onKeyDown);

        window.removeEventListener('mousedown', this.onMouseDown);
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);

        window.removeEventListener('touchstart', this.onMouseDown);
        window.removeEventListener('touchend', this.onMouseUp);
        window.removeEventListener('touchmove', this.onMouseMove);
    }
}
</script>
